import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Dimmer, Loader, Segment, Tab, Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import {style} from './style.css';
import {
    getMHCRewardsListByCategory,
} from '../../actions';
import RewardsList from '../../component/rewards/rewards_list';

class RewardsListPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isloadingActive: false,
            rewardsList: null,
        };
    }

    componentDidMount() {
        this.fetchRewardList()
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.fetchRewardList();
        }
    }

    fetchRewardList() {
        this.setState({isloadingActive: true});
        const {accessToken} = this.props.user;
        const categoryName = this.props.match.params.category;
        this.props.getMHCRewardsListByCategory(accessToken, categoryName).then(()=>{
            // console.log('getMHCRewardsListByCategory', this.props.rewardsList);
            this.setState({
                rewardsList : this.props.rewardsList
            })
            this.setState({isloadingActive: false});
        })
    }

    render() {
        // console.log('RewardsListPage', this.props.rewardsList);
        return (
          <div>
            <Dimmer active = {this.state.isloadingActive} inverted className='dimerClass' >
                    <Loader>Loading</Loader>
            </Dimmer>
            { this.state.rewardsList &&
            <RewardsList category={this.props.match.params.category} categoryName={this.props.match.params.categoryname}  rewards={this.props.rewardsList} />
            }
          </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        rewardsList: state.appConfig.rewardsList,
        contactNoVerified: state.otp.contactNoVerified
    }
}

export default connect(mapStateToProps, {
    getMHCRewardsListByCategory,
})(RewardsListPage);
